<template>
  <div class="home">
    <!-- 雪花效果 -->
    <div class="snowflakes" aria-hidden="true">
      <div v-for="n in 20" :key="n" class="snowflake">❅</div>
    </div>
    
    <div class="main-container">
      <!-- 移动端汉堡菜单 -->
      <div class="mobile-nav-toggle" @click="toggleNav">
        <div class="hamburger" :class="{ 'active': isNavOpen }">
          <span></span>
          <span></span>
          <span></span>
        </div>
      </div>

      <!-- 修改导航栏 -->
      <nav class="nav-bar" :class="{ 'nav-open': isNavOpen }">
        <div class="terminal-header">
          <div class="terminal-buttons">
            <span></span>
            <span></span>
            <span></span>
          </div>
          <div class="terminal-title">csoulkey@portfolio:~$</div>
        </div>
        <div class="nav-links">
          <a href="#hero" @click="closeNav">cd ~/home</a>
          <a href="#about" @click="closeNav">cd ~/about</a>
          <a href="#projects" @click="closeNav">cd ~/projects</a>
          <a href="#music" @click="closeNav">cd ~/music</a>
          <a href="#articles" @click="closeNav">cd ~/articles</a>
          <a href="#contact" @click="closeNav">cd ~/contact</a>
        </div>
      </nav>

      <!-- 英雄区添加id -->
      <section id="hero" class="hero">
        <div class="hero-content">
          <div class="terminal-window">
            <div class="terminal-header">
              <div class="terminal-buttons">
                <span></span>
                <span></span>
                <span></span>
              </div>
              <div class="terminal-title">welcome.sh</div>
            </div>
            <div class="terminal-body">
              <div class="line">
                <span class="prompt">$</span> whoami
              </div>
              <div class="line output">CSoulKey</div>
              <div class="line">
                <span class="prompt">$</span> cat roles.txt
              </div>
              <div class="line output">音乐人 / 全栈开发者 / AI创新者 / AIGC爱好者 / 游戏爱好者</div>
              <div class="line">
                <span class="prompt">$</span> cat introduction.txt
              </div>
              <div class="line output">
                👋 你好！我是CSoulKey，一个充满创造力的数字艺术家和技术探索者。
                <br>🎵 专注于AI音乐创作和全栈开发，致力于将技术与艺术完美融合。
                <br>🚀 正在打造下一代AI音乐创作平台，期待与你一起探索未来！
              </div>
              <div class="line">
                <span class="prompt">$</span> <span class="cursor">_</span>
              </div>
            </div>
          </div>
        </div>
      </section>

      <!-- 添加关于我区块 -->
      <section id="about" class="section">
        <div class="terminal-window">
          <div class="terminal-header">
            <div class="terminal-buttons">
              <span></span><span></span><span></span>
            </div>
            <div class="terminal-title">about.md</div>
          </div>
          <div class="terminal-body">
            <h2>关于我</h2>
            <div class="about-content">
              <p>$ cat about.txt</p>
              <p class="output">
                热衷于探索技术与艺术的交汇点，专注于AI音乐生成技术的研究与应用。
                拥有多年全栈开发经验，精通前后端技术栈。
                同时也是一名音乐创作人，作品累计播放量超过100万+。
              </p>
              <p>$ ls -la skills/</p>
              <ul class="output skills-list">
                <li>💻 前端: Vue.js, React, TypeScript, Next.js</li>
                <li>⚙️ 后端: Node.js, Python, Java, Spring Boot</li>
                <li>🎵 音乐: Logic Pro, Ableton Live, FL Studio, AI音乐生成</li>
                <li>🤖 AI/ML: TensorFlow, PyTorch, 声音处理</li>
                <li>🛠️ 其他: Docker, AWS, CI/CD, Git</li>
              </ul>
              <p>$ cat experience.txt</p>
              <ul class="output experience-list">
                <li>🏆 多个开源项目维护者</li>
                <li>📚 技术社区活跃贡献者</li>
              </ul>
              <div class="line">
                <span class="prompt">$</span> <span class="cursor">_</span>
              </div>
            </div>
          </div>
        </div>
      </section>

      <!-- 添加项目区块 -->
      <section id="projects" class="section">
        <div class="terminal-window">
          <div class="terminal-header">
            <div class="terminal-buttons">
              <span></span><span></span><span></span>
            </div>
            <div class="terminal-title">projects.json</div>
          </div>
          <div class="terminal-body">
            <h2>项目展示</h2>
            <div class="projects-grid">
              <div class="project-card">
                <h3>SunoAI.Asia</h3>
                <p>国内领先的AI音乐创作平台</p>
                <ul class="project-details">
                  <li>🎵 支持多种音乐风格生成</li>
                  <li>🤖 基于深度学习的AI作曲系统</li>
                  <li>👥 10000+ 活跃用户</li>
                  <li>🚀 每月处理超过50000次音乐生成请求</li>
                </ul>
                <a href="https://sunoai.asia" target="_blank" class="project-link">
                  $ ssh git@sunoai.asia
                </a>
              </div>
              <div class="project-card">
                <h3>幻听</h3>
                <p>AI语音社交平台</p>
                <ul class="project-details">
                  <li>🎤 实时AI声音克隆技术</li>
                  <li>💬 智能语音交互系统</li>
                  <li>🔒 私密安全的语音社交</li>
                  <li>📱 跨平台支持</li>
                </ul>
                <span class="status">Status: Coming Soon...</span>
              </div>
              <div class="project-card">
                <h3>音乐创作助手</h3>
                <p>AI驱动的音乐创作工具</p>
                <ul class="project-details">
                  <li>🎼 智能编曲功能</li>
                  <li>🎹 和声推荐系统</li>
                  <li>🎸 多种乐器音色支持</li>
                  <li>📊 作品数据分析</li>
                </ul>
                <span class="status">Status: In Development</span>
              </div>
            </div>
            <div class="line">
              <span class="prompt">$</span> <span class="cursor">_</span>
            </div>
          </div>
        </div>
      </section>

      <!-- 添加音乐区块 -->
      <section id="music" class="section">
        <div class="terminal-window">
          <div class="terminal-header">
            <div class="terminal-buttons">
              <span></span><span></span><span></span>
            </div>
            <div class="terminal-title">music.mp3</div>
          </div>
          <div class="terminal-body">
            <h2>音乐展示</h2>
            <div class="music-grid">
              <div v-for="(song, index) in songs" :key="song.id" 
                   class="music-player"
                   :class="{ 'playing': currentPlaying === song.id }">
                <div class="player-header">
                  <span class="player-status">
                    {{ currentPlaying === song.id ? '► Playing' : '◼ Stopped' }}
                  </span>
                  <span class="song-title">{{ song.title }}</span>
                </div>
                <div class="player-container">
                  <audio
                    :ref="el => { if (el) audioRefs[index] = el }"
                    :src="song.url"
                    @play="onPlay(song.id)"
                    @pause="onPause(song.id)"
                    @ended="onEnded(song.id)"
                    preload="metadata"
                  ></audio>
                  <div class="player-progress">
                    <div class="time-info">
                      <span>{{ formatTime(currentTimes[song.id] || 0) }}</span>
                      <span>{{ formatTime(durations[song.id] || 0) }}</span>
                    </div>
                    <div class="progress-bar" 
                         @click="seek($event, song.id, index)"
                         ref="progressBar">
                      <div class="progress" 
                           :style="{ width: getProgress(song.id) + '%' }">
                      </div>
                    </div>
                  </div>
                </div>
                <div class="player-controls">
                  <button class="control-btn" @click="togglePlay(song.id, index)">
                    {{ currentPlaying === song.id ? '暂停' : '播放' }}
                  </button>
                </div>
              </div>
            </div>
            <div class="line">
              <span class="prompt">$</span> play music_{{ currentPlaying || 'none' }}.mp3<span class="cursor">_</span>
            </div>
          </div>
        </div>
      </section>

      <!-- 文章区域 -->
      <section id="articles" class="articles">
        <div class="terminal-window">
          <div class="terminal-header">
            <div class="terminal-buttons">
              <span></span>
              <span></span>
              <span></span>
            </div>
            <div class="terminal-title">articles.log</div>
          </div>
          <div class="terminal-body">
            <div class="article-grid">
              <article class="article-card" v-for="n in 3" :key="n">
                <div class="article-date">[2024.03.{{ n }}]</div>
                <h3>
                  <router-link :to="`/article/${n}`" class="article-title-link">
                    构建下一代AI音乐平台
                  </router-link>
                </h3>
                <p>探索AI音乐生成技术的最新进展与应用...</p>
                <div class="article-tags">
                  <span>#AI</span>
                  <span>#音乐科技</span>
                  <span>#开发笔记</span>
                </div>
                <router-link :to="`/article/${n}`" class="read-more">
                  cat article_${n}.md
                </router-link>
              </article>
            </div>
            <div class="line">
              <span class="prompt">$</span> <span class="cursor">_</span>
            </div>
          </div>
        </div>
      </section>

      <!-- 添加联系方式区块 -->
      <section id="contact" class="section">
        <div class="terminal-window">
          <div class="terminal-header">
            <div class="terminal-buttons">
              <span></span><span></span><span></span>
            </div>
            <div class="terminal-title">contact.sh</div>
          </div>
          <div class="terminal-body">
            <h2>联系方式</h2>
            <div class="social-links">
              <a href="#" target="_blank" class="social-link">
                <i class="fab fa-bilibili"></i> Bilibili
              </a>
              <a href="#" target="_blank" class="social-link">
                <i class="fab fa-x-twitter"></i> Twitter
              </a>
              <a href="#" target="_blank" class="social-link">
                <i class="fab fa-instagram"></i> Instagram
              </a>
            </div>
            <div class="line">
              <span class="prompt">$</span> <span class="cursor">_</span>
            </div>
          </div>
        </div>
      </section>
    </div>
  </div>
</template>

<script>
export default {
  name: 'HomeView',
  data() {
    return {
      isNavOpen: false,
      currentPlaying: null,
      audioRefs: [],
      currentTimes: {},
      durations: {},
      songs: [
        { 
          id: '1', 
          title: 'Song Title 1',
          url: 'https://m704.music.126.net/20250103233053/e24d30f1875d49402e7b2ca8f5913d56/jdyyaac/obj/w5rDlsOJwrLDjj7CmsOj/56828283030/829e/064c/6566/ad87f8b378e0aa3b3e08037a2078ab6f.m4a?vuutv=iJKTcEhkVIc+qXuOcP/uMy2VlwLLnXyW98i65//T7Ayu4ZuAzLshifWiDPI1anl5rpD7FGtR5P+wPZCtjK7Tcfv1HfGtGAfNSrH4I06DTxA=&authSecret=000001942cb3933e0f1c0a32dfa20006'
        }
        // Add more songs here
      ]
    }
  },
  methods: {
    toggleNav() {
      this.isNavOpen = !this.isNavOpen
    },
    closeNav() {
      this.isNavOpen = false
    },
    formatTime(seconds) {
      const mins = Math.floor(seconds / 60);
      const secs = Math.floor(seconds % 60);
      return `${mins}:${secs.toString().padStart(2, '0')}`;
    },
    getProgress(songId) {
      const duration = this.durations[songId] || 0;
      const currentTime = this.currentTimes[songId] || 0;
      return duration ? (currentTime / duration) * 100 : 0;
    },
    seek(event, songId, index) {
      const audio = this.audioRefs[index];
      if (!audio) return;
      
      const progressBar = event.currentTarget;
      const rect = progressBar.getBoundingClientRect();
      const x = event.clientX - rect.left;
      const width = rect.width;
      const percentage = x / width;
      
      audio.currentTime = audio.duration * percentage;
    },
    togglePlay(songId, index) {
      const audio = this.audioRefs[index];
      if (!audio) return;

      if (this.currentPlaying === songId) {
        audio.pause();
      } else {
        // 停止其他正在播放的音频
        this.audioRefs.forEach((otherAudio, i) => {
          if (i !== index && otherAudio) {
            otherAudio.pause();
          }
        });
        
        audio.play();
      }
    },
    onPlay(songId) {
      this.currentPlaying = songId;
    },
    onPause(songId) {
      if (this.currentPlaying === songId) {
        this.currentPlaying = null;
      }
    },
    onEnded(songId) {
      if (this.currentPlaying === songId) {
        this.currentPlaying = null;
      }
    },
    updateProgress() {
      this.audioRefs.forEach((audio, index) => {
        if (audio) {
          const songId = this.songs[index].id;
          this.currentTimes[songId] = audio.currentTime;
          this.durations[songId] = audio.duration;
        }
      });
    }
  },
  mounted() {
    // 平滑滚动
    document.querySelectorAll('a[href^="#"]').forEach(anchor => {
      anchor.addEventListener('click', function (e) {
        e.preventDefault();
        const target = document.querySelector(this.getAttribute('href'));
        if (target) {
          target.scrollIntoView({
            behavior: 'smooth'
          });
        }
      });
    });

    // 更新进度
    setInterval(this.updateProgress, 1000);
  },
  beforeUnmount() {
    // 清理定时器
    clearInterval(this.progressInterval);
  }
}
</script>

<style scoped>
.main-container {
  min-height: 100vh;
  padding: 2rem;
}

/* 终端窗口基础样式 */
.terminal-window {
  background: var(--card-bg);
  border-radius: 8px;
  border: 1px solid var(--primary-color);
  overflow: hidden;
  margin: 2rem 0;
  box-shadow: 0 0 20px rgba(0, 255, 213, 0.1);
  padding: 1rem;
}

.terminal-header {
  background: #1a1a1a;
  padding: 0.5rem 1rem;
  display: flex;
  align-items: center;
  border-bottom: 1px solid var(--primary-color);
}

.terminal-buttons {
  display: flex;
  gap: 0.5rem;
}

.terminal-buttons span {
  width: 12px;
  height: 12px;
  border-radius: 50%;
  background: var(--primary-color);
  opacity: 0.5;
}

.terminal-title {
  margin-left: 1rem;
  color: var(--primary-color);
  font-family: 'Fira Code', monospace;
  font-size: 0.9rem;
}

/* 导航栏样式 */
.nav-bar {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  z-index: 1000;
  background: rgba(10, 10, 10, 0.8);
  backdrop-filter: blur(10px);
  border-bottom: 1px solid var(--primary-color);
}

.nav-links {
  display: flex;
  justify-content: center;
  padding: 1rem;
  gap: 2rem;
}

.nav-links a {
  color: var(--primary-color);
  text-decoration: none;
  font-family: 'Fira Code', monospace;
  transition: all 0.3s ease;
}

.nav-links a:hover {
  color: var(--accent-color);
  text-shadow: 0 0 8px var(--accent-color);
}

/* 英雄区样式 */
.hero {
  padding: 2rem 0 0 0;
}

.line {
  font-family: 'Fira Code', monospace;
  margin: 0.5rem 0;
}

.prompt {
  color: var(--primary-color);
  margin-right: 1rem;
}

.output {
  color: var(--text-color);
  margin-left: 2rem;
}

.cursor {
  animation: blink 1s infinite;
}

@keyframes blink {
  0%, 100% { opacity: 1; }
  50% { opacity: 0; }
}

/* 文章卡片样式 */
.article-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));
  gap: 2rem;
}

.article-card {
  background: rgba(0, 255, 213, 0.05);
  padding: 1.5rem;
  border-radius: 4px;
  border: 1px solid rgba(0, 255, 213, 0.1);
  transition: all 0.3s ease;
}

.article-card:hover {
  transform: translateY(-5px);
  border-color: var(--primary-color);
  box-shadow: 0 0 20px rgba(0, 255, 213, 0.2);
}

.article-date {
  color: var(--primary-color);
  font-family: 'Fira Code', monospace;
  font-size: 0.9rem;
}

.article-title-link {
  color: var(--text-color);
  text-decoration: none;
  font-size: 1.25rem;
  display: block;
  margin: 1rem 0;
  transition: color 0.3s ease;
}

.article-title-link:hover {
  color: var(--primary-color);
}

.article-tags span {
  background: rgba(0, 255, 213, 0.1);
  color: var(--primary-color);
  padding: 0.2rem 0.5rem;
  border-radius: 4px;
  font-size: 0.8rem;
  margin-right: 0.5rem;
  font-family: 'Fira Code', monospace;
}

.read-more {
  display: inline-block;
  margin-top: 1rem;
  color: var(--primary-color);
  text-decoration: none;
  font-family: 'Fira Code', monospace;
  font-size: 0.9rem;
  transition: all 0.3s ease;
}

.read-more:hover {
  color: var(--accent-color);
  text-shadow: 0 0 8px var(--accent-color);
}

/* 雪花动画 */
.snowflakes {
  position: fixed;
  width: 100vw;
  height: 100vh;
  pointer-events: none;
  z-index: 1;
}

.snowflake {
  position: absolute;
  color: var(--primary-color);
  opacity: 0.3;
  font-size: 1.5em;
  animation: fall linear infinite;
}

@keyframes fall {
  0% { transform: translateY(-100vh) rotate(0deg); }
  100% { transform: translateY(100vh) rotate(360deg); }
}

.snowflake:nth-child(1) { left: 10%; animation-duration: 12s; animation-delay: -1s; }
.snowflake:nth-child(2) { left: 20%; animation-duration: 15s; animation-delay: -2s; }
.snowflake:nth-child(3) { left: 30%; animation-duration: 11s; animation-delay: -3s; }
.snowflake:nth-child(4) { left: 40%; animation-duration: 13s; animation-delay: -4s; }
.snowflake:nth-child(5) { left: 50%; animation-duration: 14s; animation-delay: -5s; }

/* 响应式设计 */
@media (max-width: 768px) {
  .nav-links {
    flex-direction: column;
    align-items: center;
    padding: 1rem;
  }
  
  .article-grid {
    grid-template-columns: 1fr;
  }
}

/* 移动端适配 */
@media (max-width: 768px) {
  /* 导航栏移动端优化 */
  .nav-bar {
    background: var(--card-bg);
  }

  .terminal-header {
    padding: 0.5rem;
  }

  .terminal-title {
    font-size: 0.8rem;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }

  .nav-links {
    flex-direction: column;
    align-items: center;
    padding: 0.5rem;
    gap: 1rem;
  }

  .nav-links a {
    width: 100%;
    text-align: center;
    padding: 0.5rem;
    border: 1px solid rgba(0, 255, 213, 0.1);
    border-radius: 4px;
    background: rgba(0, 255, 213, 0.05);
  }

  .terminal-body {
    padding: 1rem;
  }

  .line {
    font-size: 0.9rem;
    word-break: break-word;
  }

  /* 文章区域移动端优化 */
  .article-grid {
    grid-template-columns: 1fr;
    gap: 1rem;
  }

  .article-card {
    padding: 1rem;
  }

  .article-title-link {
    font-size: 1.1rem;
  }

  .article-tags {
    display: flex;
    flex-wrap: wrap;
    gap: 0.5rem;
    margin: 0.5rem 0;
  }

  .article-tags span {
    font-size: 0.7rem;
    white-space: nowrap;
  }

  /* 确保内容不越界 */
  .terminal-window, 
  .article-card,
  .terminal-body {
    max-width: 100%;
    overflow-x: hidden;
  }

  pre {
    max-width: 100%;
    overflow-x: auto;
  }

  /* 调整雪花效果 */
  .snowflake {
    font-size: 1em;
  }
}

/* 超小屏幕适配 */
@media (max-width: 380px) {

  .terminal-title {
    font-size: 0.7rem;
  }

  .nav-links a {
    font-size: 0.9rem;
  }

  .article-date {
    font-size: 0.8rem;
  }

  .read-more {
    font-size: 0.8rem;
  }

  .main-container {
    padding: 0.5rem;
  }

}

/* 横屏模式优化 */
@media (max-height: 600px) and (orientation: landscape) {
  .hero {
    height: auto;
    min-height: 100vh;
    margin-top: 150px;
  }

  .nav-bar {
    height: auto;
  }

  .nav-links {
    flex-direction: row;
    flex-wrap: wrap;
    justify-content: center;
  }

  .nav-links a {
    width: auto;
    padding: 0.3rem 1rem;
  }
}

/* 移动端汉堡菜单 */
.mobile-nav-toggle {
  display: none;
  position: fixed;
  top: 1rem;
  right: 1rem;
  z-index: 1001;
  background: none;
  border: none;
  cursor: pointer;
}

.hamburger {
  width: 30px;
  height: 25px;
  position: relative;
}

.hamburger span {
  display: block;
  position: absolute;
  height: 2px;
  width: 100%;
  background: var(--primary-color);
  transition: 0.3s all ease;
}

.hamburger span:nth-child(1) { top: 0; }
.hamburger span:nth-child(2) { top: 50%; transform: translateY(-50%); }
.hamburger span:nth-child(3) { bottom: 0; }

.hamburger.active span:nth-child(1) {
  transform: rotate(45deg);
  top: 50%;
}

.hamburger.active span:nth-child(2) {
  opacity: 0;
}

.hamburger.active span:nth-child(3) {
  transform: rotate(-45deg);
  bottom: 40%;
}

/* 项目卡片样式 */
.projects-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
  gap: 2rem;
  padding: 1rem;
}

.project-card {
  background: rgba(0, 255, 213, 0.05);
  padding: 1.5rem;
  border-radius: 4px;
  border: 1px solid rgba(0, 255, 213, 0.1);
  transition: all 0.3s ease;
  word-wrap: break-word;
  overflow-wrap: break-word;
  max-width: 100%;
}

.project-card h3 {
  margin: 0 0 1rem 0;
  font-size: 1.2rem;
  color: var(--primary-color);
}

.project-card p {
  margin: 0.5rem 0;
  font-size: 0.9rem;
  line-height: 1.5;
}

.project-link {
  display: inline-block;
  margin-top: 1rem;
  color: var(--primary-color);
  text-decoration: none;
  font-family: 'Fira Code', monospace;
  font-size: 0.9rem;
  max-width: 100%;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

/* 社交链接样式 */
.social-links {
  display: flex;
  gap: 2rem;
  flex-wrap: wrap;
}

.social-link {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  color: var(--primary-color);
  text-decoration: none;
  font-family: 'Fira Code', monospace;
  transition: all 0.3s ease;
}

/* 移动端适配更新 */
@media (max-width: 768px) {
  .mobile-nav-toggle {
    display: block;
  }

  .nav-bar {
    transform: translateY(-100%);
    transition: transform 0.3s ease;
  }

  .nav-bar.nav-open {
    transform: translateY(0);
  }

  .nav-links {
    background: var(--card-bg);
    padding: 1rem;
    margin-top: 60px; /* 为顶部按钮留出空间 */
  }

  .nav-links a {
    display: block;
    padding: 1rem;
    text-align: left;
    border-bottom: 1px solid rgba(0, 255, 213, 0.1);
  }

  .nav-links a:last-child {
    border-bottom: none;
  }

  .social-links {
    flex-direction: column;
    gap: 1rem;
  }

  .projects-grid {
    grid-template-columns: 1fr;
    gap: 1rem;
    padding: 0.5rem;
  }

  .project-card {
    padding: 1rem;
  }

  .project-card h3 {
    font-size: 1.1rem;
  }

  .project-card p {
    font-size: 0.85rem;
  }
}

/* 音乐播放器样式 */
.music-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(330px, 1fr));
  gap: 2rem;
  padding: 1rem;
}

.music-player {
  display: flex;
  flex-direction: column;
  background: var(--card-bg);
  border-radius: 8px;
  border: 1px solid rgba(0, 255, 213, 0.1);
  transition: all 0.3s ease;
  overflow: hidden;
}

.player-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  background: #1a1a1a;
  padding: 0.5rem 1rem;
  border-bottom: 1px solid rgba(0, 255, 213, 0.1);
  font-family: 'Fira Code', monospace;
}

.song-title {
  color: var(--text-color);
  font-size: 0.9rem;
  opacity: 0.8;
}

.player-controls {
  display: flex;
  justify-content: center;
  padding: 0.5rem;
  background: rgba(0, 255, 213, 0.05);
  border-top: 1px solid rgba(0, 255, 213, 0.1);
}

.control-btn {
  background: none;
  border: 1px solid var(--primary-color);
  color: var(--primary-color);
  padding: 0.5rem 1rem;
  border-radius: 4px;
  font-family: 'Fira Code', monospace;
  cursor: pointer;
  transition: all 0.3s ease;
}

.control-btn:hover {
  background: var(--primary-color);
  color: var(--background-color);
}

.player-container {
  padding: 0.5rem;
  background: rgba(0, 255, 213, 0.02);
}

.player-status {
  color: var(--primary-color);
  font-size: 0.9rem;
  opacity: 0.8;
}

.music-player.playing {
  border-color: var(--primary-color);
  box-shadow: 0 0 20px rgba(0, 255, 213, 0.2);
}

.music-player.playing .player-status {
  opacity: 1;
  animation: pulse 2s infinite;
}

.music-player iframe {
  width: 100%;
  background: rgba(0, 255, 213, 0.05);
  border-radius: 0 0 8px 8px;
}

@keyframes pulse {
  0% { opacity: 0.8; }
  50% { opacity: 1; }
  100% { opacity: 0.8; }
}

@media (max-width: 768px) {
  .music-grid {
    grid-template-columns: 1fr;
    gap: 1rem;
    padding: 0.5rem;
  }

  .music-player {
    margin: 0.5rem 0;
  }
  
  .player-header {
    padding: 0.5rem;
  }
  
  .player-status {
    font-size: 0.8rem;
  }
}

/* 音乐播放器进度条样式 */
.player-progress {
  padding: 0.5rem 1rem;
  font-family: 'Fira Code', monospace;
}

.time-info {
  display: flex;
  justify-content: space-between;
  color: var(--primary-color);
  font-size: 0.8rem;
  margin-bottom: 0.5rem;
}

.progress-bar {
  height: 4px;
  background: rgba(0, 255, 213, 0.1);
  border-radius: 2px;
  cursor: pointer;
  position: relative;
}

.progress {
  height: 100%;
  background: var(--primary-color);
  border-radius: 2px;
  transition: width 0.1s linear;
}

.progress-bar:hover {
  height: 6px;
}

.progress-bar:hover .progress {
  background: var(--accent-color);
}

/* 技能和经验列表样式 */
.skills-list, .experience-list {
  margin-left: 2rem;
  list-style: none;
}

.skills-list li, .experience-list li {
  margin: 0.5rem 0;
  line-height: 1.6;
}

/* 项目详情样式 */
.project-details {
  list-style: none;
  padding: 0;
  margin: 1rem 0;
}

.project-details li {
  margin: 0.5rem 0;
  font-size: 0.9rem;
  color: var(--text-color);
  opacity: 0.8;
}

.project-card:hover .project-details li {
  opacity: 1;
}

/* 状态标签样式 */
.status {
  display: inline-block;
  padding: 0.3rem 0.6rem;
  background: rgba(0, 255, 213, 0.1);
  border-radius: 4px;
  font-size: 0.8rem;
  color: var(--primary-color);
  margin-top: 1rem;
}

/* 输出文本样式优化 */
.output {
  line-height: 1.6;
  color: var(--text-color);
  opacity: 0.9;
}

.output br {
  margin: 0.5rem 0;
}
</style> 